import { useDispatch, useSelector } from 'react-redux';
import { saveShippingMethod } from '../../../store/checkoutSlice';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import './shippingMethodSelector.css';

const ShippingMethodSelector = ({ setIsValid }) => {
  const dispatch = useDispatch();
  const selectedMethod = useSelector((state) => state.checkout.shippingMethod);

  const shippingOptions = [
    { value: 'free', label: 'Envío Gratuito', days: [10, 12], price: 0 },
    { value: 'standard', label: 'Envío Estándar', days: [7, 10], price: 35000 },
    { value: 'premium', label: 'Envío Premium', days: [4, 8], price: 50000 },
  ];


  const handleShippingMethodChange = (e) => {
    const method = e.target.value;
    dispatch(saveShippingMethod(method));
    setIsValid(!!method);
  };

  const getEstimatedDates = (minDays, maxDays) => {
  const today = new Date();

  const addBusinessDays = (date, days) => {
    let count = 0;
    let result = new Date(date);
    while (count < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) { // 0 = domingo, 6 = sábado
        count++;
      }
    }
    return result;
  };

  const minDate = addBusinessDays(today, minDays);
  const maxDate = addBusinessDays(today, maxDays);

  const formatDate = (date) =>
    date.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });

  return `${formatDate(minDate)} - ${formatDate(maxDate)}`;
};


  // Validación inicial
  useEffect(() => {
    setIsValid(!!selectedMethod);
  }, [selectedMethod, setIsValid]);

  return (
    <motion.div
      className="container my-5 p-4 rounded-4 shadow-sm bg-light border"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4 }}
    >
      <h3 className="text-center mb-4 fw-semibold">Selecciona el Método de Envío</h3>

      <div className="text-center mb-4">
        <img
          src="/images/servientrega400x400.png"
          alt="Servientrega"
          className="img-fluid mx-2"
          style={{ maxHeight: '50px' }}
        />
        <img
          src="/images/coordinadora.png"
          alt="Coordinadora"
          className="img-fluid mx-2"
          style={{ maxHeight: '50px' }}
        />
      </div>

      <div className="d-flex flex-column align-items-center">
        {shippingOptions.map((option) => (
          <div key={option.value} className="form-check mb-3 text-center">
            <input
              className="form-check-input"
              type="radio"
              name="shippingMethod"
              value={option.value}
              id={`${option.value}Shipping`}
              onChange={handleShippingMethodChange}
              checked={selectedMethod === option.value}
            />
            <label className="form-check-label ms-2" htmlFor={`${option.value}Shipping`}>
              {option.label} ({option.days[0]}-{option.days[1]} días hábiles) –{' '}
              <strong>${option.price.toLocaleString('es-CO')}</strong>
              <br />
              <small className="text-muted">
                📅 Llegada estimada: {getEstimatedDates(option.days[0], option.days[1])}
              </small>
            </label>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default ShippingMethodSelector;
